﻿import { initial } from 'lodash';
import React, { useState, useEffect } from 'react';
import { CheckboxWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/CheckboxWithLabel';
import { formatCurrency } from '../Currency';

export const AccessDevicesList = ({ headings = true, spotADAmount, formLang, addSelectedAccessDevices, accessDevices, currency, numberOfParkingSpots, optional = false, csr = false, locked = false, nextToProduct = false, reserved = false, availabilityPending = false }) => {

  const isAccessDeviceProduct = accessDevices ? accessDevices[0]?.Family === 'Access Device' : false;
  const mandatory = isAccessDeviceProduct || accessDevices && accessDevices.length && accessDevices.some(device => device.Required || device.Bundled)

  const [accessDevicesToDisplay, setAccessDevicesToDisplay] = useState([])
  const [selected, setSelected] = useState([])
  useEffect(() => {
    if (!accessDevices || accessDevices.length === 0) return

    const parsedAccessDevices = accessDevices
      .filter(device => (csr ? true : optional ? !(device.Required || device.Bundled) : (device.Required || device.Bundled)))
      .map(ad => {
        const spotADAmountAvailability = spotADAmount?.availability ?? []
        return {
          ...ad,
          Availability: reserved && spotADAmount?.availability ?
            (isAccessDeviceProduct ? spotADAmountAvailability[0].Availability :
            spotADAmountAvailability[spotADAmountAvailability.findIndex(item => item.ProductId === ad.ProductDetails?.ProductId)]?.Availability) :
            ad.Availability
        }
      })

      setAccessDevicesToDisplay(parsedAccessDevices)
  }, [accessDevices, spotADAmount])

  useEffect(() => {
    if (!accessDevicesToDisplay || accessDevicesToDisplay.length === 0) return

    const parsedAccessDevices = accessDevicesToDisplay.map(device => {
      return {
        id: device.ProductOptionId,
        selected: device.Required || device.Bundled || (device.Selected && device.Availability > 0),
        maxAmount: device.Availability,
        mandatory: device.Required || device.Bundled,
        ProductOption: device.ProductOptionId,
        Quantity: numberOfParkingSpots <= device.Availability ? (reserved && !device.Bundled && !device.Required ? 1 : numberOfParkingSpots) : device.Availability,
        BillingFrequency: 'One-Time',
        Name: device.ProductDetails?.Name,
        changed: device.Selected ? true : false,
        spotName: reserved && !device.Bundled && !device.Required ? [spotADAmount.spotName] : null
      }
    })

    setSelected(parsedAccessDevices)
  }, [accessDevicesToDisplay])

  useEffect(() => {
    if (!addSelectedAccessDevices) return
    if (reserved && selected.some(s => s.Quantity)) addSelectedAccessDevices(selected)
    else if (!reserved) addSelectedAccessDevices(selected.filter(device => device.selected))
  }, [selected])

  useEffect(() => {
    if (reserved || !selected || selected.length === 0) return
    setSelected(selected.map(device => ({ ...device, Quantity: device.selected && (numberOfParkingSpots <= device.maxAmount) ? numberOfParkingSpots : device.maxAmount })));
  }, [numberOfParkingSpots, spotADAmount])

  const handleSelectedAccessDevice = (event) => {
    const nearestLiId = event.target.closest("li").id;
    setSelected(selected.map(device => ({ ...device, changed: (device.id === nearestLiId) ? true : false, selected: (device.id === nearestLiId) ? !device.selected : device.selected })));
  }

  if (!csr && (nextToProduct && mandatory)) return (
    <div className="hasaccessdevice__nexttoproduct">
      <ul className="hasaccessdevice__list">
        {accessDevicesToDisplay.map(device => {
          let notAvailable = device.Availability < 1;
          return (device.Required || device.Bundled) && (<li className="hasaccessdevice__listitem" id={device.ProductOptionId || device.Id} key={device.ProductOptionId || device.Id}>
            <CheckboxWithLabel disabled={locked || device.Required || device.Bundled || notAvailable || isAccessDeviceProduct} isAccessDevice={true} value={!notAvailable && (device.Selected || device.Required || device.Bundled || isAccessDeviceProduct)}>
              <div className="hasaccessdevice__listitem--description">
              {numberOfParkingSpots && !reserved && numberOfParkingSpots > 1 && <span>{numberOfParkingSpots}× </span>}
              <span>{device.Name || device.Text}</span>
              <span>{device.ProductDetails?.Description}</span>
            </div>
            <div className="price-and-availability">
              {(!availabilityPending || !reserved) ? <span>{device.SbqqUnitPrice ? `${formatCurrency((device.SbqqUnitPrice * (!reserved && numberOfParkingSpots ? numberOfParkingSpots : 1)), true)}` : formLang.accessDevice.bundled}</span> : <span className="loadingdots"></span>}
              {(notAvailable && !availabilityPending) && <div className="hasaccessdevice__listitem--availability"><span>{formLang.accessDevice.notAvailable}</span></div>}
              </div>
            </CheckboxWithLabel>
          </li>)
        })}
      </ul>
    </div>
  )
  else if ((csr && nextToProduct && mandatory) || optional) return (
    <div className={nextToProduct ? "hasaccessdevice__nexttoproduct--csr" : ""}>
      {!nextToProduct && headings && <p><strong>Other</strong></p>}
        <div className="hasaccessdevice">
          <ul className="hasaccessdevice__list">
          {headings && <li className="hasaccessdevice__listitem hasaccessdevice__listitem--heading"><span>{formLang.accessDevice.product}</span><span className="hasaccessdevice__listitem--heading-price">{formLang.accessDevice.price}</span><span>{csr && formLang.accessDevice.availability}</span></li>}
          {accessDevicesToDisplay.map((device, i) => {
            let notAvailable = device.Availability < 1;
            let price = +device.SbqqUnitPrice || +device.UnitPrice
              return (isAccessDeviceProduct || (!device.Required && !device.Bundled && !nextToProduct) || (csr && nextToProduct && (device.Required || device.Bundled)) || (csr && !nextToProduct && !device.Required && !device.Bundled)) && (<li className="hasaccessdevice__listitem hasaccessdevice__listitem--csr" key={device.ProductOptionId || device.Id} id={device.ProductOptionId || device.Id}>
                <CheckboxWithLabel disabled={locked || device.Required || device.Bundled || notAvailable || isAccessDeviceProduct} isAccessDevice={true} value={!notAvailable && (device.Selected || device.Required || device.Bundled || isAccessDeviceProduct )} handleClick={handleSelectedAccessDevice}>
                  <div className="hasaccessdevice__listitem--description">
                    <span>{!notAvailable && !reserved && numberOfParkingSpots && numberOfParkingSpots > 1 && ((device.Availability >= numberOfParkingSpots) ? `${numberOfParkingSpots}× ` : `${device.Availability}× `)}{device.Name || device.Text}{spotADAmount && ' – ' + spotADAmount.spotName}</span>
                    <span>{device.ProductDetails?.Description}</span>
                  </div>
                  <span className="hasaccessdevice__listitem--optional">{csr && (device.Required ? formLang.accessDevice.mandatory : (device.Bundled ? formLang.accessDevice.bundled : formLang.accessDevice.optional))}</span>
                  <span className="hasaccessdevice__listitem--price"><span>Price: </span>{!availabilityPending && price ? (!reserved && price ? formatCurrency((price * ((device.Availability >= numberOfParkingSpots) ? numberOfParkingSpots : 1)), true) : formatCurrency(price, true) ?? 0) : <span className="loadingdots"></span>}</span>
                  <div className="hasaccessdevice__listitem--availability">
                    {csr && (!availabilityPending ? !notAvailable && `${device?.Availability ?? ''}` : <span className="loadingdots"></span> )}
                    {notAvailable && !availabilityPending && <span>{formLang.accessDevice.notAvailable}</span>}
                  </div>
                </CheckboxWithLabel>
              </li>)
            })
            }
          </ul>
        </div>
      </div>
    )
  else return null
}